import createReactComponent from '../createReactComponent';
var Eye = createReactComponent('Eye', [['path', {
  d: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z',
  key: '1mzqvs'
}], ['circle', {
  cx: '12',
  cy: '12',
  r: '3',
  key: '1v7zrd'
}]]);
export default Eye;